import {
  CampaignWithoutTagsFragmentDoc,
  EntityConnectionWithNotesFragmentDoc, EntityWithNotesFragmentDoc, NoteTarget,
  TaggableLogbookDetailsFragmentDoc
} from 'generated/graphql';

export function getNoteFragmentInfo(targetType: NoteTarget): { fragmentName: string; fragment: any } {
  if (targetType === NoteTarget.Entity) {
    return { fragmentName: 'EntityWithNotes', fragment: EntityWithNotesFragmentDoc };
  }

  if (targetType === NoteTarget.EntityConnection) {
    return { fragmentName: 'EntityConnectionWithNotes', fragment: EntityConnectionWithNotesFragmentDoc };
  }

  if (targetType === NoteTarget.TaggableLogbook) {
    return { fragmentName: 'TaggableLogbookDetails', fragment: TaggableLogbookDetailsFragmentDoc };
  }

  if (targetType === NoteTarget.Campaign) {
    return { fragmentName: 'CampaignWithoutTags', fragment: CampaignWithoutTagsFragmentDoc };
  }

  return undefined;
}
